import React, { ReactNode } from 'react';
import { Icons } from '@celebration/react/ClbIcon/props.types';
import { ClbIcon } from '@celebration/react/ClbIcon/ClbIcon';
import './text.scss';

interface ITextProps extends React.HTMLProps<HTMLDivElement> {
    value: string;
    icon?: Icons;
    svgIcon?: ReactNode;
}

function TextComponent({
    value,
    icon,
    svgIcon,
    className = '',
    slot,
}: Readonly<ITextProps>) {
    return (
        <p
            className={`txt ${className}`}
            slot={slot}
            data-testid="text-component"
        >
            {icon && <ClbIcon className="text-icon" icon={icon} />}
            {svgIcon ?? ''}
            {value}
        </p>
    );
}

export default TextComponent;
